import React from 'react';
import '../../style/Footer.css';
import LogoMed from '../images/LogoMed.png';

function Footer() {
  return (
    <footer className="medway-footer">
      <div className="medway-footer__grid">
        <div className="medway-footer__brand">
          <img src={LogoMed} alt='Medway Recruitment' style={{ height: 55, marginBottom: 12 }} />
          <div style={{ marginTop: 14, color: '#111D4B', fontSize: '17px', lineHeight: 1.4, maxWidth: 370 }}>
            Engagierte tunesische Fachkräfte für Krankenhäuser, Kliniken und Pflegeeinrichtungen
          </div>
        </div>

        <div className="medway-footer__links" style={{ minWidth: 240 }}>
          <div style={{ fontWeight: 600, fontSize: '1.4rem', marginBottom: 7 }}>Kontakt</div>
          <div style={{ color: '#111D4B', fontSize: '21px', marginBottom: 2 }}>+216 51 613 741</div>
          <a href='mailto:recruitmentmedway@gmail.com' style={{ color: '#111D4B', fontSize: '17px', display: 'block' }}>recruitmentmedway@gmail.com</a>
          <a href='mailto:I.hamzaoui@medwayschule.de' style={{ color: '#111D4B', fontSize: '17px', display: 'block' }}>I.hamzaoui@medwayschule.de</a>
          <a href='mailto:S.amri@medwayschule.de' style={{ color: '#111D4B', fontSize: '17px', display: 'block' }}>S.amri@medwayschule.de</a>
        </div>

        <div className="medway-footer__links">
          <div style={{ fontWeight: 600, fontSize: '1.4rem', marginBottom: 7 }}>Sitemap</div>
          <a href="/Dienstleistung" style={{ color: '#111D4B', marginBottom: 1, display: 'block', textDecoration: 'none' }}>Leistungen</a>
          <a href="/Ueber-uns" style={{ color: '#111D4B', marginBottom: 1, display: 'block', textDecoration: 'none' }}>Über uns</a>
          <a href="/Team" style={{ color: '#111D4B', marginBottom: 1, display: 'block', textDecoration: 'none' }}>Team</a>
          <a href="/#vision" style={{ color: '#111D4B', marginBottom: 1, display: 'block', textDecoration: 'none' }}>Vision-Mission</a>
          <a href="/Tunesien" style={{ color: '#111D4B', display: 'block', textDecoration: 'none' }}>Tunesien</a>
          <a href="/Kontakt" style={{ color: '#111D4B', display: 'block', textDecoration: 'none' }}>Kontakt</a>
        </div>

        <div className="medway-footer__links">
          <div style={{ fontWeight: 600, fontSize: '1.4rem', marginBottom: 7 }}>Rechtliches</div>
          <a href="/Impressum" style={{ color: '#111D4B', marginBottom: 1, display: 'block', textDecoration: 'none' }}>Impressum</a>
          <a href="/Datenschutz" style={{ color: '#111D4B', display: 'block', textDecoration: 'none' }}>Datenschutz</a>
        </div>
      </div>
      <div className="medway-footer__bottom">
        © {new Date().getFullYear()} Medway Recruitment
      </div>
    </footer>
  );
}

export default Footer;
